import { getCarrierAxiosInstance } from '../axios-config';
import IBranchFormData from '../../interfaces/IBranchFormData';
import IBranch from '../../interfaces/IBranch';
import IContact, { ICarriersContact } from '../../interfaces/IContacts';
import IBranchRegion from '../../interfaces/IBranchRegion';
import { DesserializerDecimal } from '../../../utils/formatterDecimal';

const getBranch = async (
    carrierId: string,
    branchId: string,
    t: (key: string) => string, // função de tradução
): Promise<IBranchFormData> => {
    const Api = await getCarrierAxiosInstance();

    try {
        const { data } = await Api.get<IBranch>(
            `v1/carriers/${carrierId}/branches/${branchId}`,
        );

        const branch = {
            id: data.id,
            cnpj: data.cnpj,
            corporateName: data.corporateName,
            tmsCode: data.tmsCode,
            sapCode: data.sapCode,
            eccCode: data.eccCode,
            carriersContact: {} as ICarriersContact,
            mainContact:
                data.contacts.find(c => c.mainContact) ?? ({} as IContact),
            additionalContacts: data.contacts.filter(c => !c.mainContact),
            paymentTerm: DesserializerDecimal(data.paymentTerm),
        } as IBranchFormData;

        return branch;
    } catch {
        throw new Error(t('ErroConsultarFilial'));
    }
};

const getBranchLocations = async (
    carrierId: string,
    branchId: string,
    t: (key: string) => string, // função de tradução
): Promise<IBranchRegion[]> => {
    const Api = await getCarrierAxiosInstance();

    try {
        const response = await Api.get<IBranchRegion[]>(
            `v1/carriers/${carrierId}/branches/${branchId}/locations`,
        );
        return response.data;
    } catch {
        throw new Error(t('ErroLocalizarFilial'));
    }
};

const BranchService = {
    getBranch,
    getBranchLocations,
};

export default BranchService;
